/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RoutesRoutes {
  CALL_CATEGORY_ROUTE = '/chamados/tipo-solicitacao',
  ROUTE_CALLS = '/chamados',
  ROUTE_CHANGE_PW = '/meus-dados/alterar-senha',
  ROUTE_DETAILS_CALLED = '/chamados/:nrSeqCall/detalhes',
  ROUTE_FORM_PROVIDER_ACCREDITATION_NEW = '/credenciamento/tipo-credenciamento/:nrSeqTypeAccreditation/novo',
  ROUTE_FORM_TECHNICAL_VISIT = '/form-technical-visit',
  ROUTE_MY_DATA = '/meus-dados',
  ROUTE_NEGOTIATION = '/historico-negociacoes',
  ROUTE_NEGOTIATION_TABCONTROL = '/historico-negociacoes/negociacao/:nrSeqNegotiation',
  ROUTE_NEW_CALL = '/chamados/tipo-solicitacao/:nrSeqCategory/novo',
  ROUTE_PRIVACY = '/privacidade',
  ROUTE_PRIVACY_WARNING = '/aviso-de-privacidade/:nrSeqPrivacy',
  ROUTE_PROVIDER_ACCREDITATION = '/credenciamento',
  ROUTE_TECHNICAL_VISIT = '/visita-tecnica',
  ROUTE_TERM_PROVIDER_ACCREDITATION = '/termo-credenciamento-prestador',
  ROUTE_TERM_USE = '/termo-de-uso/:nrSeqTerm',
  ROUTE_VISIT_DETAILS = '/visita-tecnica/:nrSeqVisit',
}
export { RoutesRoutes };
